import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { api } from "../lib/api";

const mdComponents = {
  h1: (p) => <h2 className="h-display text-3xl md:text-4xl mt-16 mb-6" {...p} />,
  h2: (p) => <h3 className="h-display text-2xl md:text-3xl mt-12 mb-4" {...p} />,
  p: (p) => <p className="mb-8" {...p} />,
  em: (p) => <em className="text-[var(--gold)]" {...p} />,
  blockquote: (p) => <blockquote className="border-l-2 border-[var(--gold)] pl-6 italic text-[var(--gold)] my-10" {...p} />,
};

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return (
    <main className="pt-40 min-h-[60vh] max-w-[900px] mx-auto px-6" data-testid="page-post-not-found">
      <div className="h-eyebrow mb-6">§ 404</div>
      <h1 className="h-display text-5xl md:text-6xl">This entry has been retired.</h1>
      <Link to="/journal" className="inline-block mt-10 text-[var(--gold)] border-b border-[var(--gold)]/40 pb-2 font-sans-display uppercase tracking-[0.3em] text-[11px]">Return to the Journal →</Link>
    </main>
  );

  if (!post) return <main className="pt-40 max-w-[900px] mx-auto px-6"><div className="h-eyebrow text-[var(--ink-muted)]">Loading…</div></main>;

  return (
    <main className="pt-24 md:pt-28" data-testid="page-post">
      <section className="max-w-[900px] mx-auto px-6 md:px-8">
        <Link to="/journal" className="h-eyebrow text-[var(--ink-muted)] hover:text-[var(--gold)]" data-testid="post-back-link">← The Journal</Link>
        <div className="h-eyebrow mt-6 text-[var(--gold)]">{post.category}</div>
        <h1 className="h-display text-4xl md:text-6xl lg:text-7xl leading-[1] mt-4">{post.title}</h1>
        <p className="font-serif-editorial italic text-lg md:text-xl text-[var(--ink)]/75 mt-8 leading-relaxed">{post.excerpt}</p>
      </section>

      {post.cover_image && (
        <section className="max-w-[1400px] mx-auto px-6 md:px-12 my-16 md:my-24">
          <div className="clip-frame h-[50vh] md:h-[75vh] bg-[#111]">
            <img src={post.cover_image} alt={post.title} />
          </div>
        </section>
      )}

      <section className="max-w-[760px] mx-auto px-6 pb-32 md:pb-48">
        <div className="font-serif-editorial text-xl md:text-2xl leading-[1.55] text-[var(--ink)]/85 prose-editorial">
          <ReactMarkdown components={mdComponents}>
            {post.body}
          </ReactMarkdown>
        </div>

        <div className="mt-16 pt-10 border-t border-white/5 flex items-center justify-between">
          <Link to="/journal" className="font-sans-display uppercase tracking-[0.3em] text-[11px] text-[var(--ink-muted)] hover:text-[var(--gold)]">← All entries</Link>
          <Link to="/contact" className="font-sans-display uppercase tracking-[0.3em] text-[11px] text-[var(--gold)] border-b border-[var(--gold)]/40 pb-2">Commission a Project →</Link>
        </div>
      </section>
    </main>
  );
}
